import { useState } from "react";
import locale from "localization/en";
import styles from "../cash-noncash.module.scss";
import { Title } from "components/commons";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import useDataTable from "hooks/useDataTable";
import { initialShiftRecordFilterState } from "modules/records/shift-records/shift-records-filter.state";
import ImageCarousel from "components/commons/image-carousel/image-carousel";
import { useAlert } from "hooks";
import { bankDepositMapper } from "./bank-deposit.mapper";
import { bankDepositColumn } from "./bank-deposit-column";

const ShiftDetailsBankDeposit = ({ shift }) => {
  const [imageUrl, setImageUrl] = useState("");
  const { addAlert } = useAlert();
  const { table } = useDataTable({
    value: shift?.bankDeposit,
    filter: { initialState: initialShiftRecordFilterState(), mapper: (data) => data },
    table: {
      key: "bankDeposit",
      mapper: (val) =>
        bankDepositMapper({
          val,
          onClickViewSlip: (imageUrl) => {
            if (!imageUrl) {
              return addAlert({
                title: "Oops! No Image to Show",
                subtitle: "This image isn't available right now. Please check back later.",
                type: "error",
                interval: 3000,
              });
            }
            setImageUrl(imageUrl);
          },
        }),
      columns: bankDepositColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.bankDeposits}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2 {...table} hideNoSearchResultRender tableVersion="v2" hidePagination />
        <ImageCarousel value={imageUrl} onClose={() => setImageUrl("")} />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default ShiftDetailsBankDeposit;
